import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-regular-svg-icons";
import { faFilter, faTimes, faSearch } from "@fortawesome/free-solid-svg-icons";
import { t, use } from "i18next";
import SearchBar from "components/SearchBar/SearchBar";
import "components/Select/SelectInput.css";
import "./PageHeadBar.css";
import MenuToggler from "components/MenuToggler/MenuToggler";
import Button from "components/Button/Button";
import FiltersDrawer from "./FiltersDrawer/FiltersDrawer";
import DisplayButton from "./DisplayButton/DisplayButton";
import SiteLogo from "Pages/Sites/components/SiteLogo/SiteLogo";
import useAccount from "classes/Accounts/hooks/useAccount";
import { getMenuRightTemplateKeyFromTypeId, getWriteRightFromTypeId } from "includes/mappingTypeIdName";
import { TypeRights, returnRightsFromName } from "includes/rightType";
import { useMediaQuery } from 'react-responsive'
import { useAccountContext } from "providers/AccountProvider";
import clsx from "clsx";
import { RssFilter } from "components-v2/Rss/rssFilters.component";
import useTemplate from "hooks/useTemplate";
import { useFilterContext } from "providers/FilterProvider";
import { usePostContext } from "providers/PostProvider";
import { useHistory, useLocation } from "react-router-dom";

export default function PageHeadBar(props) {
	const { account, isAdmin } = useAccount();
	const { template } = useTemplate();
	const history = useHistory();
	const [addBtnVisible, setAddBtnVisible] = useState(true);
	const { userOrAdmin } = useAccountContext();
	const [filtersMenu, setFiltersMenu] = useState(false);
	const [isBannerVisible, setIsBannerVisible] = useState(false);
	const isMobile = useMediaQuery({ query: '(max-width: 700px)' })
	const { setIsFilterOpen, isFilterOpen, searching, siteSelected, categoriesSelected, setNumberFilterActivated, numberFilterActivated, categoryIdsArray, setSearching, setSiteSelected } = useFilterContext();
	const { setPostTypeId, setPropsPageHead } = usePostContext();
	const color = template?.primaryColor();
	const location = useLocation();

	useEffect(() => {
		const templateObjs = template.getAppFunctions(true);
		const keyForTemplate = getMenuRightTemplateKeyFromTypeId(props.typeId);
		if (keyForTemplate !== "") {
			if (templateObjs[keyForTemplate] !== void 0) {
				setIsBannerVisible(!templateObjs[keyForTemplate]);
			}
		}
	}, [props.typeId]);

	// Sync the context after render (setting it during render triggers a React warning)
	useEffect(() => {
		setPostTypeId(props.typeId);
	}, [props.typeId, setPostTypeId]);

	const goToAppareance = (e) => {
		history.push("/appearance");
	};

	const checkRight = () => {
		const rigthName = getWriteRightFromTypeId(props.typeId);
		setAddBtnVisible(returnRightsFromName(account.Rights, rigthName));
		// if (
		// 	account.Rights && (
		// 		rigthName === TypeRights.AdminArticle ||
		// 		rigthName === TypeRights.AdminAlert ||
		// 		rigthName === TypeRights.AdminChart ||
		// 		rigthName === TypeRights.AdminDocument ||
		// 		rigthName === TypeRights.AdminForms ||
		// 		rigthName === TypeRights.AdminEvent
		// 	)
		// ) {
		// 	console.log("Test Write", returnRightsFromName(account.Rights, rigthName));
		// 	// try {
		// 	// 	return returnRightsFromName(account.Rights, rigthName);
		// 	// } catch (error) {
		// 	// 	return true;
		// 	// }
		// 	setAddBtnVisible(returnRightsFromName(account.Rights, rigthName));
		// }
	};

	const checkNumberOfFiltersActivated = () => {
		let count = 0;
		if (searching !== "") count++;
		if (typeof props.siteSelect === "function" && siteSelected && siteSelected.value !== 0) count++;
		if (categoryIdsArray && categoryIdsArray.length > 0) count = count + categoryIdsArray.length;
		setNumberFilterActivated(count);
	}

	useEffect(() => {
		if (props.search) {
			props.search(searching);
			checkNumberOfFiltersActivated();
		}
	}, [searching]);

	useEffect(() => {
		setSearching("");
		// setSiteSelected(null);
	}, [location.pathname, props.display]);

	useEffect(() => {
		if (siteSelected && props.siteSelect) {
			checkNumberOfFiltersActivated();
			props.siteSelect(siteSelected);
		}
	}, [siteSelected]);

	useEffect(() => {
		if (categoriesSelected) {
			props.selectCategory(categoriesSelected);
		}
	}, [categoriesSelected]);

	useEffect(() => {
		if (categoryIdsArray) {
			checkNumberOfFiltersActivated();
		}
	}, [categoryIdsArray]);

	useEffect(() => {
		if (account.Rights) {
			checkRight();
		}
	}, [account.Rights]);

	const AddButton = ({ hideTitle = false }) => (
		<div className="head-bar-btn-cont ms-auto">
			<Button
				className="headbar-add-btn btn btn-primary gap-2"
				onClick={props.handleAdd}
			>
				{!hideTitle && <div className="add-btn-title">
					{props.addTitle ? props.addTitle : t("Posts.ADD_BTN")}
				</div>}
				<span className="icons icon-edit f-15"></span>
				{/* <FontAwesomeIcon icon={faEdit} /> */}
			</Button>
		</div>
	);

	const genButtons = (buttons) => {
		if (!buttons?.length) return false;
		let ret = buttons.map((a, key) => {
			if (
				!a ||
				a.enabled === false ||
				(a.display && a.display !== props.display)
			)
				return false;
			return (
				<div
					key={key}
					className={
						"head-bar-btn-cont" +
						(a.className ? " " + a.className : "")
					}
					style={a.style}
					title={a.title}
				>
					{a.component ? (
						<a.component {...a.props} />
					) : (
						<Button
							className={
								"headbar-btn btn" +
								(a.classes ? " " + a.classes : "")
							}
							onClick={a.onClick}
						>
							<div>
								{a.icon && (
									<FontAwesomeIcon
										icon={a.icon}
										color={a.iconColor}
									/>
								)}
								{!a.iconOnly ? a.title : false}
							</div>
						</Button>
					)}
				</div>
			);
		});
		return ret;
	};

	const getFiltersCount = () => {
		let count = 0;
		count += props.dispCats?.length;
		if (userOrAdmin === "admin") {
			count += props.favSites?.length;
		}

		if (props.curSite && props.siteSelect)
			if (props.curSite?.length) count += props.curSite?.length;
			else if (props.curSite?.value !== 0) count += 1;
		if (props.filterChilds?.length)
			props.filterChilds.forEach((a) => (count += a.filterCount));
		return count;
	};

	const resetFilters = (e) => {
		e.preventDefault();
		e.stopPropagation();
		props.favSitesSelect && props.favSitesSelect([]);
		if (props.resetCatsFilter) props.resetCatsFilter();
		if (props.siteSelect) props.siteSelect(false);
		if (props.filterChilds?.length)
			props.filterChilds.forEach((a) => {
				if (a.resetFilter) a.resetFilter();
			});
	};

	const filtersCount = getFiltersCount();

	let stringifiedProps = null;
	if (props.title !== "Sites") {
		const propsToStringify = {
			...props,
		}
		propsToStringify.siteSelector = typeof props.siteSelect === "function";
		stringifiedProps = JSON.stringify(propsToStringify);
	}

	useEffect(() => {
		if (stringifiedProps !== null)
			setPropsPageHead(stringifiedProps);
	}, [stringifiedProps, setPropsPageHead]);
	return (
		<>
			{isBannerVisible && isAdmin() && <div className="banner-menuRight">{t("Posts.BANNER_MENU_RIGHT_TEXT")} <Button onClick={goToAppareance} className="unstyled text-center">{t("Posts.BANNER_MENU_RIGHT_LINK_TEXT")} </Button></div>}
			{isMobile ? (<div className="d-flex MobileHeaderBar">
				<div className="d-flex first">
					{props.menuToggler !== false && (
						<div className="d-flex align-items-center">
							<MenuToggler
								className="me-3"
								isMenuOpen={props.isMenuOpen}
								setIsMenuOpen={props.setIsMenuOpen}
							/>
						</div>
					)}
					<div className="container-searchBtnFilter">
						{numberFilterActivated > 0 && <div className="numberFilter">{numberFilterActivated}</div>}
						{/* <div onClick={() => setIsFilterOpen(!isFilterOpen)}><span className="icons icon-search f-25"></span></div> */}
						<div className="filterMobileBtn" onClick={() => setIsFilterOpen(!isFilterOpen)}>

							<svg
								className="svg-icon"
								style={{
									width: '1em',
									height: '1em',
									verticalAlign: 'middle',
									fill: 'currentColor',
									overflow: 'hidden'
								}}
								viewBox="0 0 1024 1024"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M640 288a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 288z m123.456-96c-14.304-55.04-64-96-123.456-96s-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896V192h-132.544zM640 864a64 64 0 1 1 0.032-128.032A64 64 0 0 1 640 864m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h388.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64h-132.544c-14.304-55.04-64-96-123.456-96M384 576a64 64 0 1 1 0.032-128.032A64 64 0 0 1 384 576m0-192c-59.456 0-109.152 40.96-123.456 96H128v64h132.544c14.304 55.04 64 96 123.456 96s109.152-40.96 123.456-96H896v-64H507.456c-14.304-55.04-64-96-123.456-96"
								/>
							</svg>
							<span>{t("Commons.FILTERS")}</span>

						</div>
						{/* <FontAwesomeIcon className="icon-search" color={color} icon={faFilter} /> */}
					</div>
				</div>
				{props.logo !== false && (
					<SiteLogo
						companyId={account.CompanyId}
						siteId={account.SiteId}
					/>
				)}
				{(addBtnVisible || (props.handleAdd && props.inlineAddBtn)) && !isMobile && (
					<AddButton hideTitle={true} />
				)}
				<div className="empty_element"></div>

			</div >) : (
				<div className="PageHeadBar d-flex flex-wrap justify-content-between align-items-center gap-1">
					<div
						className={
							"headbar-right-cont d-flex justify-content-between align-items-center flex-wrap mb-lg-0 gap-2" +
							(props.handleAdd ? " w-100" : "")
						}
					>
						{/* {props.menuToggler !== false && ( */}
						<div className="d-flex align-items-center">
							<MenuToggler
								className="me-3"
								isMenuOpen={props.isMenuOpen}
								setIsMenuOpen={props.setIsMenuOpen}
							/>
							<div className="page-title">{props.title}</div>
						</div>

						{/* )} */}
						{/* {props.logo !== false && (
							<SiteLogo
								companyId={account.CompanyId}
								siteId={account.SiteId}
							/>
						)} */}
						<div className="d-flex gap-2">
							{/* {props.headButtons && genButtons(props.headButtons)} */}
							{/* {(checkRight() || (props.handleAdd && !props.inlineAddBtn)) && (
						<AddButton />
					)} */}
						</div>
					</div>
					{props.showRss ? (<RssFilter />) : (
						<div
							className="headbar-left-cont gap-2"
							style={{ flex: !props.handleAdd ? "1 1 50%" : "" }}
						>
							{/* {genButtons(props.buttons)} */}
							{/* {props.filters && (
								<div>
									<Button
										title="Filtres"
										onClick={() => setFiltersMenu(!filtersMenu)}
										className={
											"filter-button " +
											(filtersMenu || filtersCount > 0
												? "btn-primary"
												: "")
										}
									>
										<FontAwesomeIcon
											className="pe-none"
											icon={faFilter}
										/>
										{filtersCount > 0 && (
											<div className="d-flex ms-2 gap-2 align-items-center">
												<div className="">{filtersCount}</div>
												<div
													className="reset-filters-btn"
													onClick={resetFilters}
													title={"Réinitialiser les sites"}
												>
													<FontAwesomeIcon icon={faTimes} />
												</div>
											</div>
										)}
									</Button>
								</div>
							)} */}
							{/* {props.display && (
								<DisplayButton
									isDisabled={props.disableDisplayBtn}
									display={props.display}
									setDisplay={props.setDisplay}
								/>
							)}
							{props.search !== false && (
								<div className="search-cont">
									<SearchBar key={props.display} onChange={props.search} timeout={500} initValue={props?.searchValue} />
								</div>
							)}
							{(addBtnVisible || (props.handleAdd && props.inlineAddBtn)) && (
								<AddButton />
							)}
							{props.cont} */}
						</div>
					)}
				</div>
			)
			}
			<div id="newFilters">
				<div className="flex">
					{props.display && (
						<DisplayButton
							isDisabled={props.disableDisplayBtn}
							display={props.display}
							setDisplay={props.setDisplay}
						/>
					)}
					{genButtons(props.buttons)}
					{props.search !== false && (
						<div className="search-cont">
							<SearchBar key={props.display} onChange={props.search} timeout={500} initValue={props?.searchValue} />
						</div>
					)}
					{(addBtnVisible || (props.handleAdd && props.inlineAddBtn)) && (
						<AddButton />
					)}
				</div>
				{props.filters &&
					(<div className="bg">
						<FiltersDrawer
							{...props}
							isMobile={false}
							hideFavSites={props.hideFavSites}
							favSitesSelect={props.favSitesSelect}
							className="w-100 mt-2"
							isOpen={true}
							onClose={() => setFiltersMenu(false)}
						/>

					</div>
					)}

			</div>
		</>
	);
}
